import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedshiftIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16636_7151)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4 30.3503L33.976 32.5233V15.4285L24.4 17.6015V30.3503Z",
					fill: "#205B97"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.976 15.4285L35.8 16.2977V31.6541L33.976 32.5233V15.4285ZM24.4 30.3503L14.824 32.5233V15.4285L24.4 17.6015V30.3503Z",
					fill: "#5193CE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.824 15.4285L13 16.2977V31.6541L14.824 32.5233V15.4285Z",
					fill: "#205B97"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.8325 36L30.4805 34.2616V13.7384L26.8325 12L25.7172 23.3965L26.8325 36Z",
					fill: "#5193CE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.9676 36L18.3196 34.2616V13.7384L21.9676 12L23.0829 23.3965L21.9676 36Z",
					fill: "#205B97"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.9675 12H26.8819V35.9516H21.9675V12Z",
					fill: "#2E73B7"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16636_7151",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22.8,
				height: 24,
				fill: "white",
				transform: "translate(13 12)"
			})
		}) })
	]
});
export default SvgRedshiftIcon;
